import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Infra Docs",
  "description": "Infra"
};
export let structuredData = {
  "contents": [{
    "heading": "what-is-next",
    "content": "Lots of info. Continue."
  }],
  "headings": [{
    "id": "what-is-next",
    "content": "What is Next?"
  }]
};
export const toc = [{
  depth: 2,
  url: "#what-is-next",
  title: _jsx(_Fragment, {
    children: "What is Next?"
  })
}];
function _createMdxContent(props) {
  const _components = {
    h2: "h2",
    li: "li",
    ol: "ol",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      id: "what-is-next",
      children: "What is Next?"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "Lots of info. Continue."
      }), "\n"]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
